import axios from "axios";
import { GetAllGGNotificationLotDTO, GetAllGGNotificationLotFiltersDTO, GetAllGGNotificationTabDTO, GetAllGGNotificationTabFiltersDTO, GGNotificationLotDTO, GGNotificationTabDTO } from "./dto";
import { GGNotificationCocService } from "./service";
import { keycloak } from "../../../../../lib/keycloak";

export class GGNotificationCoCServiceImpl implements GGNotificationCocService {

    /* LOT */
    public CreateGGNotificationLot(data: GGNotificationLotDTO): Promise<void> {
        return axios.post("/api/gg-notification-coc-lot",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public DeleteGGNotificationLot(id: string): Promise<void> {
        return axios.delete("/api/gg-notification-coc-lot/" + id,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetAllGGNotificationLot(filters: GetAllGGNotificationLotFiltersDTO): Promise<GetAllGGNotificationLotDTO> {
        return axios.get("/api/gg-notification-coc-lot", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                ggNotificationCOCTabId: filters.ggNotificationCOCTabId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetGGNotificationLotById(id: string): Promise<GGNotificationLotDTO> {
        return axios.get("/api/gg-notification-coc-lot/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    /* TAB */
    public UpdateGGNotificationTab(data: GGNotificationTabDTO, id: string): Promise<void> {
        return axios.put("/api/gg-notification-coc-tab/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public GetAllGGNotificationTab(filters: GetAllGGNotificationTabFiltersDTO): Promise<GetAllGGNotificationTabDTO> {
        return axios.get("/api/gg-notification-coc-tab", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                sort: filters.sort,
                order: filters.order,
                ggNotificationId: filters.ggNotificationId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public GetGGNotificationTabById(id: string): Promise<GGNotificationTabDTO> {
        return axios.get("/api/gg-notification-coc-tab/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }
}